module.exports = __webpack_public_path__ + "static/media/wordmark_white.5bf9b526.svg";